import { render } from "./App.vue?vue&type=template&id=0aea9a5c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0aea9a5c&lang=scss"
const cssModules = script.__cssModules = {}
import style1 from "./App.vue?vue&type=style&index=1&id=0aea9a5c&lang=scss&module=true"
cssModules["$style"] = style1
script.render = render

export default script